import {CustomEventHandler} from "../utils/CustomEventHandler";
import {CUSTOM_SCROLL, scrollSetting} from "../common/globalVars";
import {HtmlUtil} from "../utils/HtmlUtil";
import {MathUtil} from "../utils/MathUtil";

export default class MotionOeraStoryTech {
    constructor(targetEl) {
        this.targetEl = targetEl;
        this.init();
    }

    init() {
        this.addEvent();
        // if (!scrollSetting.smooth)  this.targetEl.style.position = 'sticky';
    }

    addEvent() {
        this.onScrollHandler({detail:0});
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
    }

    onScrollHandler(e) {
        let top = (HtmlUtil.getPos(this.targetEl).y - (e.detail + window.innerHeight/2));
        let width = MathUtil.map(top, 0, 300, 80, 48 );

        this.targetEl.style.width = `${width}%`;
    }
}
